// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--UDb1P","listItem":"footer-module--list-item--3L2HT","label":"footer-module--label--2eXJ8"};